import * as React from 'react';

import * as styles from './FullscreenGalleryLayout.css';

type TFullscreenGalleryLayoutProps = {
  header: React.ReactNode;
  content: React.ReactNode;
  footer: React.ReactNode;
};

export const FullscreenGalleryLayout: React.VFC<TFullscreenGalleryLayoutProps> = ({ header, content, footer }) => {
  return (
    <div className={styles['container']} data-testid="FullscreenGalleryLayout">
      {header}
      {content}
      {footer}
    </div>
  );
};
